import { useTranslation } from "react-i18next";
import "./index.scss";
type props = {
  text?: string;
};
const TableNullData = ({
  text = "There_is_no_information_to_display",
}: props) => {
  const { t } = useTranslation();
  const content = t(text);
  return (
    <tbody id="table-loading-container">
      <tr>
        <td colSpan={100}>
          <p>{content}</p>
        </td>
      </tr>
    </tbody>
  );
};

export default TableNullData;
